export default __webpack_public_path__ + "static/logo-9a2a781d3675dfb6496f4974d9cd6d05.png";